export enum PAGES {
  ROOT = "/",
  LOGIN = "/login",
  REGISTER = "/register",
  CONFIRM_EMAIL = "/confirm-email",
  VERIFY_EMAIL = "/verify-email",
  SELECT_ROLE = "/select-role",
  RESET_PASSWORD = "/reset-password",
  RESET_EMAIL = "/reset-email",
  CONFIRM_PASSWORD = "/confirm-password", 
  CONFIRM_RESET = "/confirm-reset",
  DASHBOARD = "/dashboard",
  REPORT = "/report",
  RULE = "/rule",
  CLIENT_LIST = "/clients",
  CLIENT_PAGE = "/clients/:id",
  ERROR_404 = "*",
  PROFILE = "/profile",
  ACCOUNTING = "/accounting",
  FIXED_ASSETS = "/fixed-assets",
  LIABILITIES = "/liabilities",
  PLAID_DONE = "/plaid/done",
  PRIVACY = "/privacy",
  CONNECT = "/connect/:token",
}

export type ParsedSearchParams = Record<string, string>;

export type Scheme<Endpoints extends PAGES = PAGES> = {
  scheme: Endpoints;
  params?: Record<string, string>;
  getParams?: ParsedSearchParams;
};

export type ParsedPathname = string[];

export type Path = {
  pathname: string;
  search?: string;
};

export type FeScheme = Scheme<PAGES> | [Scheme<PAGES>];
